import createConverter from './lib/create_converter';
import TopicSuggestions from 'models/topic_suggestions';

export default createConverter(TopicSuggestions);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/topic_suggestions_converter.js